'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Front = _interopRequireDefault(require("Layouts/Front"));
var _Image = _interopRequireDefault(require("Pure/Image"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const {
  app,
  qwest
} = window;
class FrontNewsDetailsPage extends _react.Component {
  state = {
    loading: false,
    status_messages: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews({});
  }
  fetchNews = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/news/get-all', {
      slug: document.location.pathname.split('/actualites/')[1]
    }).then(function (xhr, response) {
      component.setState({
        loading: false,
        news: (response.news || [])[0]
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/_react.default.createElement(_Front.default, _extends({
      page_title: state.news?.title
    }, props), /*#__PURE__*/_react.default.createElement("div", {
      className: "o-content c-blog--page"
    }, state.news?.images?.[0]?.url ? /*#__PURE__*/_react.default.createElement(_Image.default, {
      className: "c-blog-item__image",
      src: state.news.images[0].url,
      alt: state.news.title
    }) : undefined, /*#__PURE__*/_react.default.createElement("h1", {
      className: "c-title u-text-center u-margin-bottom-0"
    }, state.news?.title), /*#__PURE__*/_react.default.createElement("div", {
      className: "c-blog-item__txt",
      dangerouslySetInnerHTML: {
        __html: state.news?.description
      }
    }), state.news?.documents?.[0]?.url ? /*#__PURE__*/_react.default.createElement("a", {
      className: "c-blog-item__file",
      href: state.news.documents[0].url,
      target: "_blank",
      rel: "noreferrer"
    }, "T\xE9l\xE9charger le document") : undefined));
  }
}
exports.default = FrontNewsDetailsPage;
